/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import React from 'react';
import {
  TextField,
  Autocomplete,
  ClassNameMap,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

import Loader from '../../shared/Loader';
import { AutocompleteChangeReason, AutocompleteChangeDetails } from './types';
import { DropdownOptionPolicyFilteringFunction } from "../../models/Roles/RolesContracts";


export const SearchableList = (props: {
  options: any;
  classes: ClassNameMap<'listbox' | 'optionItemName' | 'optionItemDescription' | 'searchIcon' | 'optionItem'>;
  handleChange: (
    _event: React.ChangeEvent<{}>,
    _value: any,
    _reason: AutocompleteChangeReason,
    details?: AutocompleteChangeDetails<any> | undefined
  ) => void;
  loading: boolean;
  title: string;
  id?: string;
  value?: any;
  error?: boolean;
  placeholder?: string;
  handleDropdownFiltering?: DropdownOptionPolicyFilteringFunction;
}) => {
  const groupByClass = props.classes.optionItemName;
  const optionDescCls = props.classes.optionItemDescription;
  const optionItem = props.classes.optionItem;
  return (
    <Autocomplete
      disableClearable
      id={props.id ?? 'autocomplete_search'}
      data-testid={props.id ?? 'autocomplete_search'}
      options={props.options}
      loading={props.loading}
      value={props.value || []}
      onChange={props.handleChange}
      className={props.classes.listbox}
      filterOptions={props.handleDropdownFiltering}
      getOptionLabel={(option:any) => (option.name || option.displayName || '') }
      renderOption={(props, option:any) => { 
        return <li {...props} key = {option.id} className={optionItem}>
            <div className={groupByClass}>{option.name || ''}</div>
            <div className={optionDescCls}>{option.displayName || ""}</div>
          </li>;
      }}
      renderInput={params => (
        <TextField
          {...params}
          label={props.title}
          variant="standard"
          error={props.error}
          id="searchable-list-textfield"
          placeholder={props.placeholder}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <React.Fragment>
                <SearchIcon fontSize="small" className={props.classes.searchIcon} /> {params.InputProps.startAdornment}
              </React.Fragment>
            ),
            endAdornment: (
              <React.Fragment>
                <Loader showLoader={props.loading} />
                {params.InputProps.endAdornment}
              </React.Fragment>
            )
          }}
        />
      )}
    />
  );
};

export default SearchableList;